import {
    AfterViewInit,
    Component,
    ElementRef,
    HostBinding,
    Inject,
    OnDestroy,
    OnInit,
    Renderer2,
    ViewEncapsulation
} from '@angular/core';
import {Platform} from '@angular/cdk/platform';
import {DOCUMENT} from '@angular/common';
import {distinctUntilChanged, filter, takeUntil} from 'rxjs/operators';
import {ActivatedRoute, NavigationEnd, Router, RouterEvent} from '@angular/router';
import {InteractiveGuideService} from '@app/core/service/interactive-guide.service';
import {User} from '@app/core/model/user';
import {AuthenticatedUserService} from '@app/core/service/authenticated-user.service';
import {Subject} from 'rxjs';

@Component({
    selector: 'ngc-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MainComponent implements OnInit, AfterViewInit, OnDestroy {

    @HostBinding('attr.layout-mode') layoutMode;

    isSysAdmin: boolean;

    private unsubscribe$ = new Subject<void>();

    constructor(
        private _renderer: Renderer2,
        private _elementRef: ElementRef,
        private platform: Platform,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private interactiveGuideService: InteractiveGuideService,
        @Inject(DOCUMENT) private document: any,
        private authenticatedUserService: AuthenticatedUserService
    ) {
        if ( this.platform.ANDROID || this.platform.IOS ) {
            this.document.body.className += ' is-mobile';
        }
    }

    ngOnInit() {
        this.layoutMode = 'plain';
        this.getUser();
    }

    ngAfterViewInit() {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .pipe(distinctUntilChanged())
            .subscribe((event: RouterEvent) => {

                if (this.interactiveGuideService.isActivated()) {
                    this.interactiveGuideService.stop();
                }
            });
    }

    addClass(className: string) {
        this._renderer.addClass(this._elementRef.nativeElement, className);
    }

    removeClass(className: string) {
        this._renderer.removeClass(this._elementRef.nativeElement, className);
    }

    private getUser() {
        this.authenticatedUserService.authenticatedUser$.pipe(takeUntil(this.unsubscribe$))
            .subscribe((user: User) => {
                this.isSysAdmin = user && this.authenticatedUserService.isSysAdmin(user);
            });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
